import React from 'react';
import { Award, Briefcase, CheckCircle, BookOpen } from 'lucide-react';
import { tutorProfile } from '../mock/data';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img 
                src={tutorProfile.image}
                alt={tutorProfile.name}
                className="rounded-2xl shadow-2xl w-full object-cover"
              />
              {/* Floating Card */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center space-x-4">
                  <div className="bg-teal-100 rounded-full p-3">
                    <Award className="h-6 w-6 text-teal-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">95%</p>
                    <p className="text-sm text-gray-600">Student Satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Background Decoration */}
            <div className="absolute top-6 left-6 w-full h-full bg-teal-100 rounded-2xl -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Your Tutor
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              {tutorProfile.name}
            </h2>
            <p className="text-xl text-teal-600 font-semibold mb-6">
              {tutorProfile.title}
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {tutorProfile.bio}
            </p>

            {/* Qualifications */}
            <div className="mb-8">
              <div className="flex items-center space-x-2 mb-4">
                <Award className="h-5 w-5 text-teal-600" />
                <h3 className="text-xl font-bold text-gray-900">Qualifications</h3>
              </div>
              <div className="space-y-3">
                {tutorProfile.qualifications.map((qual, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="h-5 w-5 text-teal-600 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{qual}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Experience */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <Briefcase className="h-5 w-5 text-teal-600" />
                <h3 className="text-xl font-bold text-gray-900">Experience</h3>
              </div>
              <div className="space-y-3">
                {tutorProfile.experience.map((exp, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="h-5 w-5 text-teal-600 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{exp}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-gray-200">
              <div>
                <p className="text-3xl font-bold text-teal-600">10+</p>
                <p className="text-sm text-gray-600">Years Teaching</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-teal-600">500+</p>
                <p className="text-sm text-gray-600">Students Helped</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-teal-600">1000+</p>
                <p className="text-sm text-gray-600">Sessions Delivered</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
